import './VennWireModule.css';
import compWires from './img/compWires.png';

function VennWireModule() {


  return (
      <div>
          <h3>Complicated Wires</h3>
          <img src={compWires} width="100%" alt="Complicated Wires" />
      </div>
  );
}

export default VennWireModule;
